import { Box, Link, Typography } from '@mui/material'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import S3Image from 'Components/S3Image'
import { TryFormatPhoneNumber } from 'core/Utilities'
import { type CareManagementContact } from './types'

interface CareManagementContactCardProps {
  contacts: CareManagementContact[]
}

export function CareManagementContactCard (props: CareManagementContactCardProps): JSX.Element {
  return (
    <Box data-testid='careManagementCard' sx={{ backgroundColor: '#ECEDEF', borderRadius: '10px', px: '20px', py: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <Box>
        <Typography sx={{ color: '#222024', fontSize: '18px', fontWeight: 600 }}>Care Management</Typography>
        <Typography sx={{ color: '#514F53', fontSize: '12px' }}>
          If you have more questions or need help please reach out to the contact below!
        </Typography>
      </Box>
      {props.contacts.map(contact => (
        <Box key={contact.serviceProviderID} data-testid={`careManagementContact-${contact.serviceProviderID}`} sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {contact.logoS3Key != null && contact.logoS3Key !== '' &&
              <S3Image imageKey={contact.logoS3Key} alt={contact.name} style={{ width: '24px', height: '24px' }} />}
            <Typography sx={{ color: '#222024', fontSize: '14px', fontWeight: 600 }} data-testid='careManagementName'>{contact.name}</Typography>
          </Box>
          {contact.phone != null && contact.phone !== '' && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <PhoneIcon sx={{ color: '#222024' }} />
              <Link href={`tel:${contact.phone}`} underline='none' sx={{ color: '#222024', fontSize: '14px' }} data-testid='careManagementPhone'>
                {TryFormatPhoneNumber(contact.phone)}
              </Link>
            </Box>
          )}
          {contact.email != null && contact.email !== '' && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <EmailIcon sx={{ color: '#222024' }} />
              <Link href={`mailto:${contact.email}`} sx={{ color: '#7136BC', fontSize: '14px' }} data-testid='careManagementEmail'>
                {contact.email}
              </Link>
            </Box>
          )}
        </Box>
      ))}
    </Box>
  )
}
